import { ResumeSchoolEnum } from '@src/types/resumeDetail/campusType';
import request from '@utils/request';

// 查询简历
export async function getResumeDetail(params: { source: string }) {
  const res = await request.post('/api/official/resume/get', params);
  return res;
}

// 预览简历
export async function getPreview(params: string) {
  const res = await request.get(`/api/official/resume/attachment/preview?fileId=${params}`);
  return res;
}

// 解析简历
export async function analyzeResume(params) {
  const res = await request.post('/api/official/resume/attachment/analyze', params);
  return res;
}

// 上传头像

export async function uploadPhoto(params) {
  const res = await request.post('/api/official/resume/photo/upload', params);
  return res;
}

// 获取城市列表
export async function getCityList(params) {
  const res = await request.post('/api/official/city/search', params);
  return res;
}

// 证件号-二要素校验
export const verifyIdentification = async (params) => {
  const res = await request.post('/api/official/verify/identification', params);
  return res;
};

// 获取枚举接口，类型的枚举
export enum GetEnumByCategoryEnum {
  // 实验室级别——laboratoryLevel
  laboratoryLevel = 'laboratoryLevel',
  // 技能类型——skill
  skill = 'skill',
  // # 技能等级——skillLevel
  skillLevel = 'skillLevel',
  // # 性别枚举—— gender
  gender = 'gender',
  // # 证件类型枚举 —— idType
  idType = 'idType',
  // # 学历枚举 —— diploma
  diploma = 'diploma',
  // # 工作类型 —— workType
  workType = 'workType',
  // # 成绩排名枚举 —— rank
  rank = 'rank',
  // # 竞赛枚举 —— competition
  competition = 'competition',
  // # 语言种类枚举 —— language
  language = 'language',
  // # 语言水平枚举 —— languageLevel
  languageLevel = 'languageLevel',
  // # 论文发表作者顺序枚举 —— authorOrder
  authorOrder = 'authorOrder',
  // # 论文发表渠道枚举 —— thesisLevel
  thesisLevel = 'thesisLevel',
  // # 社交网站名 —— socialNetWorkSiteName
  socialNetWorkSiteName = 'socialNetWorkSiteName',
  // # 国际区号--interCode
  interCode = 'interCode',
}
// 获取枚举接口入参类型
export interface IGetEnumByCategoryParams {
  // category: GetEnumByCategoryEnum;
  category: string;
  parentCategory?: string;
  filter?: string;
}
export async function getEnumByCategory(params: IGetEnumByCategoryParams) {
  // 获取简历详情页相关枚举
  const res = await request.post(`/api/official/enum/getEnumByCategory`, params);
  return res;
}

// 获取竞赛，级联
export async function getTreeEnumByCategory(params: IGetEnumByCategoryParams) {
  // 获取简历详情页相关枚举
  const res = await request.post(`/api/official/enum/getTreeEnumByCategory`, params);
  return res;
}

// 获取当前存在哪些类型
export async function getResumeEnum(params?: {}) {
  const res = await request.post('/api/official/resume/isExist', params);
  return res;
}

// 毕业学校枚举
export async function getSchoolEnum(params: {}) {
  const res = await request.post<ResumeSchoolEnum[]>('/api/official/enum/search/school', params);
  return res;
}

// 专业枚举
export async function getMajorEnum(params: {}) {
  const res = await request.post('/api/official/enum/search/major', params);
  return res;
}
// 学院枚举
export async function getCollegeEnum(params: {}) {
  const res = await request.post('/api/official/enum/search/college', params);
  return res;
}
// 公司枚举
export async function getCompanyEnum(params: {}) {
  const res = await request.post('/api/official/enum/search/company', params);
  return res;
}

// 保存简历
export async function saveResume(params: {}) {
  const res = await request.post('/api/official/resume/save', params);
  return res;
}

// 获取简历公共字段
export async function getCommonResume(params: {}) {
  const res = await request.post('/api/official/resume/getCommonField', params);
  return res;
}

// 上传附件接口(附件类型（2-作品，4-简历原件)
export function uploadAttachment(type: string) {
  const res = `/api/official/resume/attachment/upload?fileTypeCode=${type}`;
  return res;
}

// 获取用户信息
export async function getUserInfo() {
  const res = await request.post('/api/official/user/current/resume/get');
  return res;
}

/** 上传简历后更新元数据 */
export async function updateMetaData(params: {
  fileName: string;
  fileId: string;
  fileSize: number;
  fileTypeCode: '4' | '2';
}): Promise<void> {
  const res = await request.post('/api/official/attachment/updateMetaData', params);
  return res;
}

/**
 * 获取证件类型
 */
export async function getIdTypeData() {
  const res = await request.post('/api/official/nationalIdType/get');
  return res;
}
